import React, { useEffect, useCallback } from "react";
import { Route, Switch } from "react-router-dom";

import Admin from "../components/Admin/Admin";
import Dashboard from "../containers/Dashboard/Dashboard";
import ApplicationForm from "../components/Form/ApplicationForm/ApplicationForm";
import ApplicationList from "../containers/Applications/ApplicationList";
import AgreementDocumentsList from "../components/List/AgreementDocumentsList";
import Preview from "../components/Preview/Preview";
import ConfidentialQuestionnaire from "../components/Form/ConfidentialQuestionnaire/ConfidentialQuestionnaire";
import BasicApplicationForm from "../components/Form/BasicApplicationForm/BasicApplicationForm";
import ProfileForm from "../components/Form/ProfileForm/ProfileForm";

import { handleCandidateFirstLogin } from "../requests/users";
import { candidateId, currentCandidateData } from "../recoil/candidate/atom";
import { useSetRecoilState } from "recoil";
// import { loadSubsites } from "../requests/subsites";
// import { subsitesData } from "../recoil/subsites/atom";
import { isUrlPathActive } from "../utils/urlHelper";
import { loadJobStatuses, loadJobTypes, loadOccupations } from "../requests/jobs";

import { getCurrentCandidate } from "../requests/candidates";
import { jobTypesData } from "../recoil/jobTypes/atom";
import { jobStatusData } from "../recoil/jobStatus/atom";
import { occupationsData } from "../recoil/occupations/atom";
import styles from "./App.module.scss";
import "react-widgets/scss/styles.scss";
import { loadNoteTypes } from "../requests/notes";
import { noteTypesData } from "../recoil/notetypes/atom";

const App = () => {
  const setCandidateIdValue = useSetRecoilState(candidateId); 
  //const setSubSitesData = useSetRecoilState(subsitesData);
  const setJobTypesData = useSetRecoilState(jobTypesData);
  const setJobStatusData = useSetRecoilState(jobStatusData);
  const setOccupationsData = useSetRecoilState(occupationsData);
  const setCurrentCandidateData = useSetRecoilState(currentCandidateData);
  const setNoteTypesData = useSetRecoilState(noteTypesData);
  
  const setLogRocket = (user) => {
    if (window.location.hostname.match("qjumpersjobs.co") || window.location.hostname.match("qjumpers.jobs")) {
      //const user = result[4].data;
      if (window.LogRocket) {
        window.LogRocket.init("tumufv/qjumpers-public");
        window.LogRocket.identify(user.id, {
          name: user.firstName + " " + user.lastName,
          email: user.email,
          // Add your own custom user variables here, ie:
          site: window.location.host,
        });
      }
    }
  }

  const loadReferenceData = useCallback(() => {
      if (!!isUrlPathActive("quickapplications")) {
        Promise.all([loadJobTypes(), loadJobStatuses(), loadOccupations(), loadNoteTypes()])
        .then((result) => {
          if (result.length === 4) {
            let showAPIErrorPop = false;
            showAPIErrorPop = setReferenceData(result, showAPIErrorPop);
          }
        }).catch((error) => {
          console.log("Error in loading reference data", error);
        });
      } else {
        Promise.all([loadJobTypes(), loadJobStatuses(), loadOccupations(), loadNoteTypes(), getCurrentCandidate()])
        .then((result) => {
          if (result.length === 5) {
            let showAPIErrorPop = false;
            showAPIErrorPop = setReferenceData(result, showAPIErrorPop);
            if (result[4].data) {
              setCurrentCandidateData(result[4].data); 
              setLogRocket(result[4].data);
            } else {
              showAPIErrorPop = true;
            }
          }
        })
        .catch((error) => {
          console.log("Error in loading reference data else", error);
        });
      }
  }, []);

  useEffect(() => {
    if (!!!isUrlPathActive("quickapplications")) {
      handleCandidateFirstLogin().then((result) => {
        if (result.data) {
          setCandidateIdValue(result.data);
        }
        loadReferenceData();
      });
    }
  }, []);

  return (
    <div className={styles.app}>
      <div className={styles.appPage}>
        <div className={styles.appContent + " container"}>
          <Switch>
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/applications/:type/:jobId" component={ApplicationForm} />
            <Route path="/application/reviewdocument/:applicationId" component={AgreementDocumentsList} />
            <Route path="/application/previewdocument/:id" component={Preview} />
            <Route path="/applications/:type?/:page?/:size?" component={ApplicationList} />
            <Route path="/confidentialquickapply/:type/:jobId" component={ConfidentialQuestionnaire} />
            <Route path={["/quickapplications/:type/:jobId", "/basicapplications/:type/:jobId"]} component={BasicApplicationForm} />
            <Route path="/admin" component={Admin} />
            <Route path="/profile" component={ProfileForm} />
          </Switch>
        </div>
      </div>
    </div>
  );

  function setReferenceData(result, showAPIErrorPop) {
    if (result[0].data) {
      setJobTypesData(result[0].data);
    } else {
      showAPIErrorPop = true;
    }
    if (result[1].data) {
      setJobStatusData(result[1].data);
    } else {
      showAPIErrorPop = true;
    }
    if (result[2].data) {
      setOccupationsData(result[2].data);
    } else {
      showAPIErrorPop = true;
    }
    if (result[3].data) {
      setNoteTypesData(result[3].data);
    } else {
      showAPIErrorPop = true;
    }
    return showAPIErrorPop;
  }
};

export default App;
